module.exports = __webpack_public_path__ + "img/icon-176.4d232e45.png";